import {replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { chain, LoadRealTimeInventory } from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

/* istanbul ignore next */
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(chain, LoadRealTimeInventory,  props => {
    if (
        !props.productInfos ||
        props.productInfos.length === 0 ||
        (props.dataViewHasProducts && props.parameter.isShellEdit)
    ) {
        return;
    }

    props.dispatch(
            loadRealTimeInventory({
            productIds: props.productInfos.map(o => o.productId),
            expand: ["warehouses"],
            onSuccess: realTimeInventory => {
                props.dispatch({
                    type: "Components/ProductInfoLists/CompleteLoadRealTimeInventory",
                    id: props.parameter.id,
                    realTimeInventory,
                });
            },
            onError: () => {
                props.dispatch({
                    type: "Components/ProductInfoLists/FailedLoadRealTimeInventory",
                    id: props.parameter.id,
                });
            },
            onComplete(realTimeInventoryProps) {
                if (realTimeInventoryProps.apiResult) {
                    this.onSuccess?.(realTimeInventoryProps.apiResult);
                } else if (realTimeInventoryProps.error) {
                    this.onError?.(realTimeInventoryProps.error);
                }
            },
        }),
    );
});
